<template>
  <div class="bidder-page">
    <!-- 搜索区域 -->
    <div class="search-section">
      <el-form :model="searchForm" :inline="true" class="search-form">
        <el-form-item>
          <el-input v-model="searchForm.bidSectionName" placeholder="标段名称" clearable style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">
            查询
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <div class="table-section">
      <el-table :data="tableData" border style="width: 100%" v-loading="loading"
        :empty-text="loading ? '加载中...' : '暂无数据'">
        <el-table-column type="index" label="NO." width="60" align="center" :index="indexMethod"></el-table-column>
        <el-table-column prop="bidInviteName" label="邀请书名称" min-width="200">
          <template slot-scope="scope">
            <div>
              <el-link type="primary" :underline="false" @click="handleView(scope.row)">{{ scope.row.bidInviteName
              }}</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="bidSectionName" label="标段名称" min-width="150"></el-table-column>
        <el-table-column prop="bidDocumentSubmissionDeadline" label="文件递交截止时间" min-width="180"
          align="center"></el-table-column>
        <el-table-column prop="bidInviteEndTime" label="回复截止时间" min-width="180" align="center"></el-table-column>
        <el-table-column prop="tenderFee" label="标书费(元)" min-width="120" align="center"></el-table-column>
        <el-table-column prop="drawingDepositFee" label="图纸押金(元)" min-width="120" align="center"></el-table-column>
        <el-table-column prop="orderStatus" label="订单状态" min-width="120" align="center">
          <template slot-scope="scope">
            <span>{{ getOrderStatusText(scope.row.orderStatus) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="registerStatus" label="报名状态" min-width="120" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1 && scope.row.isNeedRegister === 1">{{ getRegisterStatusText(scope.row.registerStatus) }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="260" align="center" class-name="action-column">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleView(scope.row)">查看</el-button>
            <template v-if="scope.row.status === 1">
              <template v-if="scope.row.isNeedRegister === 1">
                <el-button v-if="scope.row.registerStatus == null || scope.row.registerStatus === -1 || scope.row.registerStatus === 0 || scope.row.registerStatus === 3"
                  type="text" size="small" @click="handleRegistrationFromList(scope.row)">报名</el-button>
                <span v-else-if="scope.row.registerStatus === 1" class="status-pending-text">报名待审核</span>
                <el-button v-else-if="scope.row.registerStatus === 9 && scope.row.orderStatus !== 1 && needsPurchase(scope.row)"
                  type="text" size="small" @click="handlePurchase(scope.row)">购标</el-button>
              </template>
              <template v-else>
                <el-button v-if="scope.row.orderStatus !== 1 && needsPurchase(scope.row)" type="text" size="small"
                  @click="handlePurchase(scope.row)">购标</el-button>
              </template>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-section">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- 详细信息弹窗 -->
    <el-dialog title="详细信息" :visible.sync="detailDialogVisible" width="60%" :append-to-body="true"
      :close-on-click-modal="false" :close-on-press-escape="false" class="detail-dialog" :show-close="false">
      <template slot="title">
        <div class="dialog-header">
          <span class="dialog-title">详细信息</span>
          <el-button type="text" size="small" @click="closeDetailDialog">关闭</el-button>
        </div>
      </template>

      <div class="detail-content" v-loading="detailLoading">
        <!-- 信息展示区域 -->
        <div class="info-section">
          <el-row :gutter="40">
            <el-col :span="12">
              <div class="info-item">
                <label>投标邀请书名称：</label>
                <span>{{ currentDetail.bidInviteName || '-' }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="info-item">
                <label>投标邀请发出时间：</label>
                <span>{{ currentDetail.bidInviteIssueTime || '-' }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="40">
            <el-col :span="12">
              <div class="info-item">
                <label>文件获取开始时间：</label>
                <span>{{ currentDetail.biddingDocumentAcquisitionStartTime || '-' }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="info-item">
                <label>文件获取结束时间：</label>
                <span>{{ currentDetail.biddingDocumentAcquisitionEndTime || '-' }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="40">
            <el-col :span="12">
              <div class="info-item">
                <label>文件递交截止时间：</label>
                <span>{{ currentDetail.bidDocumentSubmissionDeadline || '-' }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="info-item">
                <label>回复截止时间：</label>
                <span>{{ currentDetail.bidInviteEndTime || '-' }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="40">
            <el-col :span="12">
              <div class="info-item">
                <label>文件获取方法/平台地址：</label>
                <span>{{ currentDetail.biddingDocumentAcquisitionMethod || '-' }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="info-item">
                <label>文件递交方法/平台地址：</label>
                <span>{{ currentDetail.bidDocumentSubmissionMethod || '-' }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="40">
            <el-col :span="12">
              <div class="info-item">
                <label>投标资格：</label>
                <span>{{ currentDetail.bidQualification || '-' }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="info-item">
                <label>备注：</label>
                <span>{{ currentDetail.remark || '-' }}</span>
              </div>
            </el-col>
          </el-row>
        </div>

        <!-- 附件部分 -->
        <div class="attachment-section">
          <div class="section-title">附件</div>
          <el-table :data="attachmentList" border style="width: 100%" v-loading="attachmentLoading"
            :empty-text="attachmentLoading ? '加载中...' : '暂无附件'">
            <el-table-column type="index" label="No." width="60" align="center"></el-table-column>
            <el-table-column prop="fileName" label="文件名" min-width="200"></el-table-column>
            <el-table-column prop="fileExtension" label="文件类型" width="100" align="center"></el-table-column>
            <el-table-column prop="fileSize" label="文件大小" width="120" align="center">
              <template slot-scope="scope">
                <span>{{ formatFileSize(scope.row.fileSize) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="handleDownload(scope.row)">下载</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 回复内容区域 -->
        <div class="reply-section">
          <div class="section-title">邀请单位回复内容：</div>
          <el-input type="textarea" v-model="replyContent" :rows="6" placeholder="请输入回复内容"></el-input>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <template v-if="currentDetail.status == 1">
          <el-tag type="success" size="medium">已同意投标邀请</el-tag>
        </template>
        <template v-else-if="currentDetail.status == 2">
          <el-tag type="danger" size="medium">已拒绝投标邀请</el-tag>
        </template>
        <template v-else>
          <el-button type="primary" @click="handleAgree" :loading="replyLoading">同意投标邀请</el-button>
          <el-button type="primary" @click="handleReject" :loading="replyLoading">拒绝投标邀请</el-button>
        </template>
      </div>
    </el-dialog>

    <!-- 购标弹窗 -->
    <el-dialog title="购标" :visible.sync="purchaseDialog.visible" width="80%" :close-on-click-modal="false"
      :close-on-press-escape="false" :append-to-body="true" class="purchase-dialog">
      <div class="purchase-content" v-loading="purchaseDialog.loading">
        <!-- 投标人信息 -->
        <div class="bidder-info-section">
          <div class="form-grid">
            <!-- 左列 -->
            <div class="form-column">
              <div class="form-item">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>投标联系人：</label>
                <el-input v-model="purchaseDialog.form.contactPerson" placeholder="请输入投标联系人"></el-input>
              </div>
              <div class="form-item">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>电话：</label>
                <el-input v-model="purchaseDialog.form.phone" placeholder="请输入电话"></el-input>
              </div>
              <div class="form-item">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>邮编：</label>
                <el-input v-model="purchaseDialog.form.postalCode" placeholder="请输入邮编"></el-input>
              </div>
              <div class="form-item">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>通信地址：</label>
                <el-input v-model="purchaseDialog.form.address" placeholder="请输入通信地址"></el-input>
              </div>
            </div>
            <!-- 右列 -->
            <div class="form-column">
              <div class="form-item">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>开发票公司名称：</label>
                <el-input v-model="purchaseDialog.form.invoiceCompanyName" placeholder="请输入开发票公司名称"></el-input>
              </div>
              <div class="form-item">
                <label>购标日期：</label>
                <el-input v-model="purchaseDialog.form.purchaseDate" disabled></el-input>
              </div>
              <div class="form-item">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>手机：</label>
                <el-input v-model="purchaseDialog.form.mobile" placeholder="请输入手机号"></el-input>
              </div>
              <div class="form-item">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>邮箱：</label>
                <el-input v-model="purchaseDialog.form.email" placeholder="请输入邮箱"></el-input>
              </div>
            </div>
          </div>
        </div>
        <!-- 费用明细 -->
        <div class="cost-details-section">
          <h3 class="section-title">费用明细</h3>
          <el-table :data="costDetails" border style="width: 100%">
            <el-table-column prop="sectionCode" label="标段编码" width="200"></el-table-column>
            <el-table-column prop="sectionName" label="标段名称" min-width="300"></el-table-column>
            <el-table-column prop="documentPrice" label="招标文件售价(元)" width="140"></el-table-column>
            <el-table-column prop="drawingDeposit" label="图纸押金(元)" width="120"></el-table-column>
            <el-table-column prop="offlinePaymentNote" label="线下缴费说明" min-width="250"></el-table-column>
          </el-table>
        </div>
        <!-- 订单汇总和付款 -->
        <div class="order-summary-section">
          <div v-if="purchaseRefundReason" class="refund-reason-box">
            <i class="el-icon-warning"></i>
            <span>退回原因：{{ purchaseRefundReason }}</span>
          </div>
          <div class="order-total">
            <div class="order-number" v-if="purchaseDialog.form.orderNumber">
              <label>订单号：</label>
              <span class="order-number-value">{{ purchaseDialog.form.orderNumber }}</span>
            </div>
            <div class="total-amount">
              <span class="total-text">
                订单合计金额(元)：<span class="amount">{{ getOrderTotalAmount() }}元</span>
                <span class="amount-detail">(其中标书款:{{ purchaseDialog.form.tenderFee || 0 }}元, 图纸押金:{{
                  purchaseDialog.form.drawingDepositFee || 0 }}元)</span>
              </span>
            </div>
          </div>
          <div class="payment-section">
            <div class="payment-method">
              <label>付款方式：</label>
              <el-input value="线下支付" disabled style="width: 200px;"></el-input>
            </div>
          </div>
        </div>

        <!-- 文件上传 -->
        <div class="upload-section">
          <h3 class="section-title">文件上传</h3>
          <div class="upload-area">
            <el-button type="primary" icon="el-icon-upload2" @click="handlePurchaseUploadDocument">本地上传</el-button>
            <div class="el-upload__tip">支持的文件类型：PDF、Word、图片等，单个文件不能超过10GB</div>
          </div>
          <div class="uploaded-files">
            <el-table :data="purchaseDialog.uploadedFiles" border style="width: 100%">
              <el-table-column prop="fileName" label="文件名称" min-width="200"></el-table-column>
              <el-table-column prop="uploadTime" label="上传时间" width="150"></el-table-column>
              <el-table-column prop="uploader" label="上传人" width="120"></el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="handlePurchaseDeleteFile(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancelPurchase" icon="el-icon-close">关闭</el-button>
        <el-button v-if="currentOrderStatus !== 2 && currentOrderStatus !== 3 && currentOrderStatus !== 1"
          type="primary" @click="handlePlaceOrder" icon="el-icon-check"
          :loading="purchaseDialog.submitLoading">下订单</el-button>
      </div>
    </el-dialog>

    <!-- 报名弹窗 -->
    <el-dialog title="报名信息" :visible.sync="registrationDialog.visible" width="80%" :close-on-click-modal="false"
      :close-on-press-escape="false" :append-to-body="true" class="registration-dialog">
      <div class="registration-content" v-loading="registrationDialog.loading">
        <div class="section-info-section">
          <h3 class="section-title">标段(包)信息</h3>
          <div v-if="registrationRejectReason" class="reject-reason-box">
            <i class="el-icon-warning"></i>
            <span>退回原因：{{ registrationRejectReason }}</span>
          </div>
          <div class="form-grid">
            <div class="form-column">
              <div class="form-item required">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>标段(包)名称：</label>
                <el-input v-model="registrationDialog.form.sectionName" disabled></el-input>
              </div>
              <div class="form-item">
                <label>投标单位：</label>
                <el-input v-model="registrationDialog.form.bidderName" disabled></el-input>
              </div>
              <div class="form-item required">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>投标联系人：</label>
                <el-input v-model="registrationDialog.form.contactPerson" placeholder="请输入投标联系人"></el-input>
              </div>
            </div>
            <div class="form-column">
              <div class="form-item required">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>手机：</label>
                <el-input v-model="registrationDialog.form.mobile" placeholder="请输入手机号" maxlength="11"
                  @input="registrationDialog.form.mobile = sanitizeMobileInput(registrationDialog.form.mobile)"></el-input>
              </div>
              <div class="form-item required">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>邮箱：</label>
                <el-input v-model="registrationDialog.form.email" placeholder="请输入邮箱"></el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="upload-section">
          <h3 class="section-title">上传报名资料</h3>
          <el-table :data="uploadDocuments" border style="width: 100%">
            <el-table-column prop="registrationName" label="资料名称"></el-table-column>
            <el-table-column prop="registrationDescription" label="说明"></el-table-column>
            <el-table-column label="已上传文件">
              <template slot-scope="scope">
                <span v-if="!scope.row.fileName && !scope.row.uploadFileId" class="not-uploaded">未上传</span>
                <span v-else-if="scope.row.uploadFileId && !scope.row.fileName" class="uploaded-status">已上传</span>
                <span v-else>{{ scope.row.fileName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button type="success" size="small" @click="handleUploadDocument(scope.row)">本地上传</el-button>
                <el-button type="danger" size="small" @click="handleDeleteDocument(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancelRegistration" icon="el-icon-close">取消</el-button>
        <el-button type="primary" @click="handleSubmitRegistration" icon="el-icon-check">提交</el-button>
      </div>
    </el-dialog>

    <!-- 文件上传进度对话框 -->
    <el-dialog title="文件上传" :visible.sync="uploadProgress.visible" width="400px" :close-on-click-modal="false"
      :close-on-press-escape="false" :append-to-body="true" :show-close="false">
      <div class="upload-progress-content">
        <div class="upload-info">
          <i class="el-icon-upload" style="font-size: 24px; color: #409EFF; margin-right: 10px;"></i>
          <span>{{ uploadProgress.fileName }}</span>
        </div>
        <el-progress :percentage="uploadProgress.percentage"
          :status="uploadProgress.status === 'success' ? 'success' : (uploadProgress.status === 'error' ? 'exception' : null)"
          style="margin-top: 20px;">
        </el-progress>
        <div class="upload-status" style="margin-top: 10px; text-align: center;">
          <span v-if="uploadProgress.status === 'uploading'">正在上传...</span>
          <span v-else-if="uploadProgress.status === 'success'" style="color: #67C23A;">上传成功</span>
          <span v-else-if="uploadProgress.status === 'error'" style="color: #F56C6C;">上传失败</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { myInvitationSections, myInvitationDetail, replyInvitation } from '@/api/modules/invitationLetter'
import { getFileList } from '@/api/modules/base'
import { getOrCreateBySectionCode, submitOrder, getRegisterInfo, addRegister } from '@/api/modules/tenderNotice'
import { timeUtils, UPLOAD_CONSTANTS, VALIDATION_RULES } from '@/utils/base'
import { doFileUpload } from '@/utils/upload/fileUploadHelper'
import { createErrorHandler } from '@/utils/handleError'
import Cookies from 'js-cookie'

export default {
  name: 'UploadBid',
  data() {
    return {
      fileBindId: '',
      bidSectionCode: '',
      searchForm: {
        bidSectionName: ''
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      tableData: [],
      // 弹窗相关数据
      detailDialogVisible: false,
      detailLoading: false,
      attachmentLoading: false,
      currentDetail: {},
      attachmentList: [],
      replyContent: '',
      replyLoading: false,
      // 防抖定时器
      searchTimer: null,
      // 购标弹窗相关数据
      purchaseDialog: {
        visible: false,
        loading: false,
        submitLoading: false,
        form: {
          bidderName: '',
          contactPerson: '',
          phone: '',
          postalCode: '',
          address: '',
          invoiceCompanyName: '',
          purchaseDate: '',
          mobile: '',
          paymentMethod: 'offline',
          projectName: '',
          sectionName: '',
          tenderFee: 0,
          orderNumber: '',
          orderPrice: 0,
          drawingDepositFee: 0,
          bidSectionCode: '',
          email: ''
        },
        uploadedFiles: []
      },
      costDetails: [],
      // 报名相关数据
      currentRowIsNeedRegister: 0,
      currentRowBidSectionName: '',
      registrationDialog: {
        visible: false,
        loading: false,
        form: {
          sectionName: '',
          bidderName: '',
          contactPerson: '',
          mobile: '',
          email: ''
        }
      },
      uploadDocuments: [],
      currentRegistrationSection: null,
      registrationRejectReason: '',
      uploadProgress: { visible: false, percentage: 0, fileName: '', status: null }
    }
  },
  mounted() {
    this.loadData()
    this.fileBindId = Date.now().toString() + Math.floor(Math.random() * 100000)
    this.errorHandler = createErrorHandler(this)
  },
  beforeDestroy() {
    // 清理定时器
    if (this.searchTimer) {
      clearTimeout(this.searchTimer)
    }
  },
  methods: {

    // 加载数据
    loadData() {
      this.loading = true
      const params = {
        bidSectionName: this.searchForm.bidSectionName || undefined,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      }
      // 获取数据
      myInvitationSections(params).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records || []
          this.total = res.data.total || 0
        } else {
          this.$message.error(res.message || '获取数据失败')
        }
      }).catch(error => {
        console.error('获取数据失败:', error)
        this.$message.error('获取数据失败')
      }).finally(() => {
        this.loading = false
      })
    },
    handleSearch() {
      // 清除之前的定时器
      if (this.searchTimer) {
        clearTimeout(this.searchTimer)
      }
      // 设置防抖
      this.searchTimer = setTimeout(() => {
        this.currentPage = 1
        this.loadData()
      }, 300)
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.loadData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadData()
    },
    // 序号计算
    indexMethod(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1
    },
    // 订单状态文本转换
    getOrderStatusText(status) {
      const statusMap = {
        0: '未支付',
        1: '已支付',
        2: '核实退回',
        3: '待核实'
      }
      return statusMap[status] || '-'
    },
    // 报名状态文本转换
    getRegisterStatusText(status) {
      if (status == null || status === '') return '未报名'
      const map = {
        '-1': '未报名',
        '0': '暂存',
        '1': '提交待审核',
        '3': '已退回',
        '9': '审核通过'
      }
      return map[String(status)] || '-'
    },
    handleView(row) {
      this.bidSectionCode = row.bidSectionCode
      this.currentRowIsNeedRegister = row.isNeedRegister
      this.currentRowBidSectionName = row.bidSectionName
      this.myInvitationDetail(row.bidSectionCode)
    },
    //  请求详情接口
    myInvitationDetail(bidSectionCode) {
      this.detailLoading = true
      this.detailDialogVisible = true
      myInvitationDetail({ bidSectionCode: bidSectionCode }).then(res => {
        if (res.code === 200) {
          // 设置详情数据
          this.currentDetail = res.data || {}
          // 设置回复内容
          this.replyContent = res.data.bidderReplyContent || ''
          // 清空附件列表
          this.attachmentList = []
          // 获取附件列表
          if (res.data.fileGuid) {
            this.getFileList(res.data.fileGuid)
          }
        } else {
          this.$message.error(res.msg || '获取详情失败')
          this.detailDialogVisible = false
        }
      }).catch(error => {
        console.error('获取详情失败:', error)
        this.$message.error('获取详情失败')
        this.detailDialogVisible = false
      }).finally(() => {
        this.detailLoading = false
      })
    },
    //  获取附件列表
    getFileList(fileGuid) {
      this.attachmentLoading = true
      getFileList(fileGuid).then(res => {
        if (res.code === 200) {
          this.attachmentList = res.data || []
        } else {
          this.$message.error(res.msg || '获取附件列表失败')
        }
      }).catch(error => {
        console.error('获取附件列表失败:', error)
        this.$message.error('获取附件列表失败')
      }).finally(() => {
        this.attachmentLoading = false
      })
    },
    // 关闭详情弹窗
    closeDetailDialog() {
      if (this.replyLoading) {
        return
      }
      this.detailDialogVisible = false
      this.currentDetail = {}
      this.attachmentList = []
      this.replyContent = ''
      this.bidSectionCode = ''
    },
    // 回复接口
    handleDownload(row) {
      // 下载附件
      if (row.fileUrl) {
        window.open(row.fileUrl, '_blank')
      } else {
        this.$message.warning('文件地址不存在')
      }
    },
    //同意
    handleAgree() {
      if (!this.replyContent || !this.replyContent.trim()) {
        this.$message.warning('请填写回复内容')
        return
      }
      if (!this.bidSectionCode) {
        this.$message.error('标段信息缺失，请重新打开详情')
        return
      }
      this.replyInvitation('1')
    },
    // 拒绝
    handleReject() {
      if (!this.replyContent || !this.replyContent.trim()) {
        this.$message.warning('请填写拒绝原因')
        return
      }
      if (!this.bidSectionCode) {
        this.$message.error('标段信息缺失，请重新打开详情')
        return
      }
      this.$confirm('确定要拒绝此投标邀请吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.replyInvitation('2')
      }).catch(() => {
        // 取消操作
      })
    },
    //投标人回复
    replyInvitation(replyStatus) {
      this.replyLoading = true
      replyInvitation({
        bidSectionCode: this.bidSectionCode,
        replyStatus: replyStatus,
        replyContent: this.replyContent.trim(),
      }).then(res => {
        if (res.code === 200) {
          this.$message.success(replyStatus === '1' ? '已同意投标邀请' : '已拒绝投标邀请')
          this.closeDetailDialog()
          this.detailDialogVisible = false
          // 同意邀请且需要报名 → 打开报名弹窗
          if (replyStatus === '1' && this.currentRowIsNeedRegister === 1) {
            this.$nextTick(() => {
              this.openRegistrationFromAgree(this.bidSectionCode, this.currentRowBidSectionName)
            })
          }
          this.loadData()
        } else {
          this.$message.error(res.msg || '回复失败')
        }
      }).catch(error => {
        console.error('投标人回复失败:', error)
        this.$message.error('回复失败，请稍后重试')
      }).finally(() => {
        this.replyLoading = false
      })
    },
    // 格式化文件大小
    formatFileSize(size) {
      if (!size) return '-'
      if (size < 1024) return size + ' B'
      if (size < 1024 * 1024) return (size / 1024).toFixed(2) + ' KB'
      return (size / (1024 * 1024)).toFixed(2) + ' MB'
    },

    // 判断是否需要购标（有费用）
    needsPurchase(row) {
      const totalFee = (row.tenderFee || 0) + (row.drawingDepositFee || 0)
      return totalFee > 0
    },

    // ========== 报名相关方法 ==========

    // 列表点击报名
    handleRegistrationFromList(row) {
      this.currentRegistrationSection = row
      this.getRegisterInfoData(row.bidSectionCode)
    },

    // 同意邀请后打开报名弹窗
    openRegistrationFromAgree(bidSectionCode, bidSectionName) {
      this.currentRegistrationSection = { bidSectionCode, bidSectionName }
      this.registrationDialog.form.sectionName = bidSectionName || ''
      this.registrationDialog.form.bidderName = Cookies.get('userName') || ''
      this.getRegisterInfoData(bidSectionCode)
    },

    // 获取报名信息
    async getRegisterInfoData(bidSectionCode) {
      try {
        this.registrationDialog.loading = true
        const response = await getRegisterInfo({ bidSectionCode })
        if (response.code === 200) {
          const data = response.data
          const source = (data && data.bidRegistration) ? data.bidRegistration : (data || {})
          this.registrationRejectReason = source.reason || ''
          this.registrationDialog.form = {
            sectionName: this.registrationDialog.form.sectionName || source.bidSectionName || '',
            bidderName: this.registrationDialog.form.bidderName || source.bidder || Cookies.get('userName') || '',
            contactPerson: source.relationUser || '',
            mobile: source.userPhone || '',
            email: source.email || ''
          }
          const registrationFiles = (data.registrationFiles || []).map(file => ({
            ...file,
            fileGuid: file.uploadFileId || file.fileGuid || ''
          }))
          this.uploadDocuments = registrationFiles
          this.registrationDialog.visible = true
        } else {
          this.$message.error(response.msg || '获取报名信息失败')
        }
      } catch (error) {
        this.errorHandler.handleError(error, '获取报名信息失败')
      } finally {
        this.registrationDialog.loading = false
      }
    },

    // 取消报名
    handleCancelRegistration() {
      this.registrationDialog.visible = false
      this.resetRegistrationForm()
    },

    // 提交报名
    async handleSubmitRegistration() {
      if (!this.validateRegistrationForm()) return
      try {
        this.registrationDialog.loading = true
        const requestData = this.buildRegistrationRequestData()
        const response = await addRegister(requestData)
        if (response.code === 200) {
          this.$message.success('报名提交成功！')
          this.registrationDialog.visible = false
          this.resetRegistrationForm()
          this.loadData()
        } else {
          this.$message.error(response.msg || '提交失败')
        }
      } catch (error) {
        this.errorHandler.handleError(error, '报名提交失败')
      } finally {
        this.registrationDialog.loading = false
      }
    },

    // 构建报名请求数据
    buildRegistrationRequestData() {
      return {
        id: null,
        status: '1',
        bidRegistration: {
          bidSectionCode: this.currentRegistrationSection.bidSectionCode,
          relationUser: this.registrationDialog.form.contactPerson,
          userTel: '',
          userPhone: this.registrationDialog.form.mobile,
          email: this.registrationDialog.form.email
        },
        registrationFiles: this.uploadDocuments.map(document => ({
          registrationGuid: document.registrationGuid,
          uploadFileId: document.fileGuid,
          fileGuid: document.fileGuid
        }))
      }
    },

    // 验证报名表单
    validateRegistrationForm() {
      const form = this.registrationDialog.form
      if (!form.contactPerson || !form.contactPerson.trim()) {
        this.$message.error('请输入投标联系人')
        return false
      }
      if (!form.mobile || !form.mobile.trim()) {
        this.$message.error('请输入手机号')
        return false
      }
      if (!VALIDATION_RULES.mobile.test(form.mobile)) {
        this.$message.error('请输入正确的手机号格式')
        return false
      }
      if (!form.email || !form.email.trim()) {
        this.$message.error('请输入邮箱')
        return false
      }
      if (!VALIDATION_RULES.email.test(form.email)) {
        this.$message.error('请输入正确的邮箱格式')
        return false
      }
      if (this.uploadDocuments && this.uploadDocuments.length > 0) {
        const missingDocs = this.uploadDocuments.filter(doc => !doc.uploadFileId && !doc.fileName)
        if (missingDocs.length > 0) {
          const names = missingDocs.map(d => d.registrationName).join('、')
          this.$message.error('请上传以下报名资料：' + names)
          return false
        }
      }
      return true
    },

    // 重置报名表单
    resetRegistrationForm() {
      this.registrationDialog.form = {
        sectionName: '',
        bidderName: '',
        contactPerson: '',
        mobile: '',
        email: ''
      }
      this.uploadDocuments = []
      this.currentRegistrationSection = null
      this.registrationRejectReason = ''
    },

    // 上传报名资料
    handleUploadDocument(row) {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = UPLOAD_CONSTANTS.SUPPORTED_FILE_TYPES
      input.onchange = (e) => {
        this.handleFileSelect(e, row)
      }
      input.click()
    },

    // 处理文件选择
    async handleFileSelect(event, row) {
      const file = event.target.files[0]
      if (!file || !this.validateFile(file)) return
      try {
        this.showUploadProgress(file)
        const uploadResult = await this.uploadFileWithChunks(file, row)
        this.handleUploadResult(uploadResult, file, row)
      } catch (error) {
        this.handleUploadError(error, file)
      }
    },

    // 验证文件
    validateFile(file) {
      const maxSize = 10 * 1024 * 1024 * 1024
      if (file.size > maxSize) {
        this.$message.error('文件大小不能超过10GB')
        return false
      }
      return true
    },

    // 分片上传
    async uploadFileWithChunks(file, row) {
      const fileBindId = Date.now().toString() + Math.floor(Math.random() * 100000)
      if (row && row.registrationGuid) {
        const idx = this.uploadDocuments.findIndex(doc => doc.registrationGuid === row.registrationGuid)
        if (idx > -1) {
          this.$set(this.uploadDocuments[idx], 'fileGuid', fileBindId)
        }
      }
      let uploadedFileId = null
      const uploadResult = await doFileUpload(file, {
        fileBindId: fileBindId,
        onProgress: (progress) => {
          this.uploadProgress.percentage = Math.round(Number(progress) || 0)
        },
        onSuccess: (r) => {
          uploadedFileId = r.fileId || r.id || ''
          if (row && row.registrationGuid) {
            const idx = this.uploadDocuments.findIndex(doc => doc.registrationGuid === row.registrationGuid)
            if (idx > -1 && uploadedFileId) {
              this.uploadDocuments[idx].uploadFileId = uploadedFileId
            }
          }
        },
        onError: () => {}
      })
      if (uploadResult && uploadedFileId) {
        uploadResult.fileId = uploadedFileId
      }
      return uploadResult
    },

    // 显示上传进度
    showUploadProgress(file) {
      this.uploadProgress = {
        visible: true,
        percentage: 0,
        fileName: file.name,
        status: 'uploading'
      }
    },

    // 处理上传结果
    handleUploadResult(uploadResult, file, row) {
      if (uploadResult && uploadResult.success) {
        this.uploadProgress.status = 'success'
        this.uploadProgress.percentage = 100
        if (row && row.registrationGuid) {
          const idx = this.uploadDocuments.findIndex(doc => doc.registrationGuid === row.registrationGuid)
          if (idx > -1) {
            this.$set(this.uploadDocuments[idx], 'fileName', file.name)
          }
        }
        setTimeout(() => {
          this.uploadProgress.visible = false
          this.$message.success('文件 ' + file.name + ' 上传成功')
        }, 1000)
      } else {
        this.uploadProgress.status = 'error'
        setTimeout(() => {
          this.uploadProgress.visible = false
          this.$message.error('文件上传失败: ' + (uploadResult?.message || '未知错误'))
        }, 1000)
      }
    },

    // 处理上传错误
    handleUploadError(error) {
      this.uploadProgress.status = 'error'
      setTimeout(() => {
        this.uploadProgress.visible = false
        this.$message.error('文件上传失败: ' + (error.message || '未知错误'))
      }, 1000)
    },

    // 删除报名资料
    handleDeleteDocument(row) {
      this.$confirm('确定要删除该文档吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.clearFileInfo(row)
        this.$message.success('删除成功')
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },

    // 清除文件信息
    clearFileInfo(row) {
      Object.assign(row, {
        fileName: null,
        fileList: [],
        fileGuid: null,
        filePath: null,
        uploadFileId: null
      })
    },

    // 手机号输入过滤
    sanitizeMobileInput(value) {
      return (value || '').replace(/\D/g, '').slice(0, 11)
    },

    // 购标相关方法
    handlePurchase(row) {
      this.getOrCreateBySectionCodeData(row, true)
    },

    // 获取购标数据
    async getOrCreateBySectionCodeData(row, isDetail = false) {
      try {
        this.purchaseDialog.loading = true
        const response = await getOrCreateBySectionCode({ sectionCode: row.bidSectionCode })
        if (response.code === 200) {
          if (isDetail) this.openPurchaseDialog(row, response.data)
        } else {
          this.$message.error(response.msg || '获取购标数据失败')
        }
      } catch (error) {
        console.error('获取购标数据失败:', error)
        this.$message.error('获取购标数据失败')
      } finally {
        this.purchaseDialog.loading = false
      }
    },

    // 打开购标弹窗
    openPurchaseDialog(row, data) {
      const sectionCode = data.bidSectionCode || row.bidSectionCode || ''
      const sectionName = data.bidSectionName || row.bidSectionName || ''
      const tenderFee = data.tenderFee || 0
      const drawingDepositFee = data.drawingDepositFee || 0

      this.purchaseDialog.form = {
        bidderName: row.agencyName || '',
        contactPerson: data.relationUser || '',
        phone: data.userTel || '',
        postalCode: data.postalCode || '',
        address: data.address || '',
        invoiceCompanyName: data.invoiceName || data.billingCompany || '',
        purchaseDate: timeUtils.getCurrentTime(),
        mobile: data.userPhone || '',
        paymentMethod: data.payType === 1 ? 'offline' : 'online',
        projectName: row.projectName || '',
        sectionName: sectionName,
        tenderFee: tenderFee,
        orderNumber: data.orderNumber || '',
        orderPrice: data.orderPrice || 0,
        drawingDepositFee: drawingDepositFee,
        bidSectionCode: sectionCode,
        email: data.email || ''
      }

      this.costDetails = [{
        sectionCode: sectionCode,
        sectionName: sectionName,
        documentPrice: tenderFee,
        drawingDeposit: drawingDepositFee,
        offlinePaymentNote: data.paymentInstructions || ''
      }]

      this.currentOrderStatus = data.orderStatus
      this.purchaseRefundReason = data.biddingDocumentsRefundReason || ''

      this.purchaseDialog.visible = true
    },

    // 计算订单总金额
    getOrderTotalAmount() {
      const tenderFee = parseFloat(this.purchaseDialog.form.tenderFee) || 0
      const drawingDepositFee = parseFloat(this.purchaseDialog.form.drawingDepositFee) || 0
      return (tenderFee + drawingDepositFee).toFixed(2)
    },

    // 取消购标
    handleCancelPurchase() {
      this.purchaseDialog.visible = false
      this.resetPurchaseForm()
    },

    // 重置购标表单
    resetPurchaseForm() {
      this.purchaseDialog.form = {
        bidderName: '',
        contactPerson: '',
        phone: '',
        postalCode: '',
        address: '',
        invoiceCompanyName: '',
        purchaseDate: '',
        mobile: '',
        paymentMethod: 'offline',
        projectName: '',
        sectionName: '',
        tenderFee: 0,
        orderNumber: '',
        orderPrice: 0,
        drawingDepositFee: 0,
        bidSectionCode: '',
        email: ''
      }
      this.purchaseDialog.uploadedFiles = []
      this.costDetails = []
      this.currentOrderStatus = null
      this.purchaseRefundReason = ''
    },

    // 购标文件上传
    handlePurchaseUploadDocument() {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = '.pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png'
      input.onchange = (e) => {
        const file = e.target.files[0]
        if (file) {
          this.uploadPurchaseFile(file)
        }
      }
      input.click()
    },

    // 上传购标文件
    async uploadPurchaseFile(file) {

      console.log(file);

      try {
        const uploadResult = await doFileUpload(file, {
          fileBindId: this.fileBindId,
          onProgress: (progress) => {
            console.log('上传进度:', progress)
          },
          onSuccess: (result) => {
            console.log('上传成功:', result)
          },
          onError: (error) => {
            console.error('上传失败:', error)
          }
        })

        if (uploadResult && uploadResult.fileId) {
          this.purchaseDialog.uploadedFiles.push({
            fileName: file.name,
            uploadTime: timeUtils.getCurrentTime(),
            uploader: '当前用户',
            fileId: uploadResult.fileId,
            fileUrl: uploadResult.fileUrl
          })
          this.$message.success('文件上传成功')
        }
      } catch (error) {
        console.error('文件上传失败:', error)
        this.$message.error('文件上传失败')
      }
    },

    // 删除购标文件
    handlePurchaseDeleteFile(row) {
      this.$confirm('确定要删除此文件吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const index = this.purchaseDialog.uploadedFiles.findIndex(item => item.fileId === row.fileId)
        if (index > -1) {
          this.purchaseDialog.uploadedFiles.splice(index, 1)
          this.$message.success('删除成功')
        }
      }).catch(() => {
        // 取消操作
      })
    },

    // 下订单
    async handlePlaceOrder() {
      // 表单校验
      if (!this.purchaseDialog.form.contactPerson) {
        this.$message.warning('请输入投标联系人')
        return
      }
      if (!this.purchaseDialog.form.phone) {
        this.$message.warning('请输入电话')
        return
      }
      if (!this.purchaseDialog.form.postalCode) {
        this.$message.warning('请输入邮编')
        return
      }
      if (!this.purchaseDialog.form.address) {
        this.$message.warning('请输入通信地址')
        return
      }
      if (!this.purchaseDialog.form.invoiceCompanyName) {
        this.$message.warning('请输入开发票公司名称')
        return
      }
      if (!this.purchaseDialog.form.mobile) {
        this.$message.warning('请输入手机号')
        return
      }
      if (!this.purchaseDialog.form.email) {
        this.$message.warning('请输入邮箱')
        return
      }

      try {
        this.purchaseDialog.submitLoading = true
        const uploadFiles = this.purchaseDialog.uploadedFiles
          .filter(file => file.fileId)
          .map(file => ({ uploadFileId: file.fileId }))

        const params = {
          relationUser: this.purchaseDialog.form.contactPerson,
          userTel: this.purchaseDialog.form.phone,
          userPhone: this.purchaseDialog.form.mobile,
          postalCode: this.purchaseDialog.form.postalCode,
          address: this.purchaseDialog.form.address,
          buyBidTime: this.purchaseDialog.form.purchaseDate,
          payType: this.purchaseDialog.form.paymentMethod === 'offline' ? 1 : 2,
          uploadFiles,
          email: this.purchaseDialog.form.email,
          billingCompany: this.purchaseDialog.form.invoiceCompanyName,
          sectionCode: this.purchaseDialog.form.bidSectionCode
        }
        const response = await submitOrder(params)
        if (response.code === 200) {
          this.$message.success('订单提交成功')
          this.purchaseDialog.visible = false
          this.resetPurchaseForm()
          this.loadData()
        } else {
          this.$message.error(response.msg || '订单提交失败')
        }
      } catch (error) {
        console.error('订单提交失败:', error)
        this.$message.error('订单提交失败，请稍后重试')
      } finally {
        this.purchaseDialog.submitLoading = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.bidder-page {
  .apply-minimal-gray-theme();
}

/* 详细信息弹窗样式 */
.detail-dialog {
  /deep/ .el-dialog__header {
    padding: 20px 24px;
    border-bottom: 1px solid @gray-200;
    background: @gray-50;
  }

  /deep/ .el-dialog__body {
    background: @gray-50;
  }
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.dialog-title {
  font-size: 17px;
  font-weight: 600;
  color: @gray-800;
}

.detail-content {
  padding: 20px 0;
}

/* 信息展示区域 */
.info-section {
  margin-bottom: 30px;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: @shadow-sm;
}

.info-item {
  margin-bottom: 20px;
  line-height: 32px;

  label {
    display: inline-block;
    min-width: 180px;
    color: @gray-700;
    font-size: 14px;
    font-weight: 600;
  }

  span {
    color: @gray-600;
    font-size: 14px;
  }
}

/* 附件部分 */
.attachment-section,
.reply-section {
  margin-bottom: 30px;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: @shadow-sm;
}

.section-title {
  font-size: 15px;
  font-weight: 600;
  color: @gray-800;
  margin-bottom: 16px;
  padding-bottom: 10px;
  border-bottom: 2px solid @primary-color;
  position: relative;
  padding-left: 12px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 3px;
    height: 20px;
    background: @primary-color;
    border-radius: 2px;
  }
}


/* 底部按钮 */
.dialog-footer {
  text-align: center;
  padding: 16px 0;

  /deep/ .el-button {
    margin: 0 10px;
    padding: 10px 30px;
    transition: all @transition-base ease;

    &:hover {
      transform: translateY(-1px);
    }
  }
}

/* 购标弹窗样式 */
.purchase-dialog {
  /deep/ .el-dialog__header {
    padding: 20px 24px;
    border-bottom: 1px solid @gray-200;
    background: @gray-50;
  }

  /deep/ .el-dialog__body {
    background: @gray-50;
  }
}

.purchase-content {
  padding: 20px;
}

.bidder-info-section,
.cost-details-section,
.order-summary-section,
.upload-section {
  margin-bottom: 24px;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: @shadow-sm;
}

.refund-reason-box {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 16px;
  padding: 10px 14px;
  background: @error-bg;
  border: 1px solid @error-border;
  border-radius: 4px;
  color: @error-color;
  font-size: 13px;
  line-height: 1.6;

  i {
    margin-top: 2px;
    flex-shrink: 0;
  }
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.form-column {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-item {
  display: flex;
  align-items: center;

  label {
    min-width: 150px;
    color: @gray-700;
    font-size: 14px;
    white-space: nowrap;
  }

  /deep/ .el-input {
    flex: 1;
  }
}

.order-total {
  background: @gray-50;
  padding: 16px;
  border-radius: 4px;
  border-left: 3px solid @primary-color;
  margin-bottom: 16px;
}

.order-number {
  margin-bottom: 12px;
  font-size: 14px;
  color: @gray-700;
}

.order-number-value {
  color: @primary-color;
  font-weight: 600;
}

.total-amount {
  font-size: 14px;
}

.total-text .amount {
  color: @primary-color;
  font-size: 18px;
  font-weight: 600;
  margin: 0 5px;
}

.total-text .amount-detail {
  color: @gray-600;
  font-size: 12px;
  margin-left: 10px;
}

.payment-section {
  padding: 16px;
}

.payment-method {
  display: flex;
  align-items: center;
  margin-bottom: 12px;

  label {
    min-width: 100px;
    color: @gray-700;
    font-size: 14px;
  }
}

.upload-area {
  margin-bottom: 16px;
}

.el-upload__tip {
  color: @gray-500;
  font-size: 12px;
  margin-top: 8px;
}

.uploaded-files {
  margin-top: 16px;
}

/* 报名弹窗样式 */
.registration-dialog {
  /deep/ .el-dialog__header {
    padding: 20px 24px;
    border-bottom: 1px solid @gray-200;
    background: @gray-50;
  }

  /deep/ .el-dialog__body {
    background: @gray-50;
  }
}

.registration-content {
  .section-info-section,
  .upload-section {
    margin-bottom: 24px;
    padding: 20px;
    background: #fff;
    border-radius: 4px;
    box-shadow: @shadow-sm;
  }

  .reject-reason-box {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 16px;
    padding: 10px 14px;
    background: @error-bg;
    border: 1px solid @error-border;
    border-radius: 4px;
    color: @error-color;
    font-size: 13px;
    line-height: 1.6;

    i {
      margin-top: 2px;
      flex-shrink: 0;
    }
  }

  .not-uploaded {
    color: @error-color;
    background: @error-bg;
    border: 1px solid @error-border;
    padding: 4px 10px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
  }

  .uploaded-status {
    color: @success-color;
    background: @success-bg;
    border: 1px solid @success-border;
    padding: 4px 10px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
  }
}

/* 上传进度弹窗 */
.upload-progress-content {
  padding: 20px;

  .upload-info {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: @gray-700;
  }
}
/* 操作列按钮间距 */
/deep/ .action-column .el-button--text {
  margin: 0 6px;
}

.status-pending-text {
  color: #909399;
  font-size: 12px;
  margin: 0 6px;
}
</style>
